import { Outlet } from 'react-router-dom';
import { Activity } from 'lucide-react';
import Sidebar from './Sidebar';
import { WorkspaceSelector } from './WorkspaceSelector';
import { UserMenu } from './UserMenu';
import { useLiveSync } from '@/hooks/useLiveSync';

export default function AppShell() {
  useLiveSync();
  return (
    <div className="flex h-screen overflow-hidden bg-gray-50 dark:bg-gray-900">
      <Sidebar />
      <div className="flex flex-col flex-1 overflow-hidden">
        <header className="flex items-center justify-between px-6 py-3 bg-white dark:bg-gray-800 border-b border-brand-border dark:border-gray-700 shrink-0 h-[60px]">
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 rounded-lg bg-brand-primary flex items-center justify-center shrink-0">
                <Activity size={14} className="text-white" />
              </div>
              <span className="font-heading font-bold text-brand-dark dark:text-white text-sm hidden sm:block">
                Dispatcher
              </span>
            </div>
            <WorkspaceSelector />
          </div>
          <UserMenu />
        </header>
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
